<template>
  <div class="frombody">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="254px"
      labelPosition="left"
      class="registerform"
    >
      <!-- 名字-->
      <el-form-item label="名字" prop="name">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>

      <!--姓氏      -->
      <el-form-item label="姓氏" prop="surname">
        <el-input v-model="ruleForm.surname"></el-input>
      </el-form-item>

      <!--邮箱地址      -->
      <el-form-item label="邮箱地址" prop="mail">
        <el-input v-model="ruleForm.mail"></el-input>
      </el-form-item>
      <!--联系电话      -->
      <el-form-item label="联系电话" prop="phone">
        <el-input v-model="ruleForm.phone"></el-input>
      </el-form-item>

      <!--公司名称      -->
      <el-form-item label="公司名称" prop="company">
        <el-input v-model="ruleForm.company"></el-input>
      </el-form-item>

      <!--问题-->
      <el-form-item label="问题" prop="content">
        <el-input type="textarea" v-model="ruleForm.content"></el-input>
      </el-form-item>

      <!-- <el-form-item label="" class="xieyeitem" prop="checked" label-width="0">
	    <el-checkbox class="xieyi"  v-model="ruleForm.checked">我已阅读并接受  <span class="yinsi">隐私政策</span></el-checkbox>
	  </el-form-item> -->

      <el-form-item prop="checked" class="xieyeitem">
        <el-checkbox-group class="xieyeitemgroup" v-model="ruleForm.checked">
          <el-checkbox class="xieyi" name="checked"
            >当您提交信息后，我们将会以邮件或电话的方式回复您，请您阅读我们的<router-link
              :to="{ name: 'privacy' }"
              target="_blank"
              tag="a"
              >隐私政策</router-link
            >,我们将严格按照您同意的<router-link
              :to="{ name: 'privacy' }"
              target="_blank"
              tag="a"
              >隐私政策</router-link
            >使用您的个人信息。</el-checkbox
          >
        </el-checkbox-group>
      </el-form-item>

      <el-form-item class="mybotton">
        <el-button round type="primary" @click="onSubmit('ruleForm')"
          >提交</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    var revalidatexieyi = (rule, value, callback) => {
      if (value === false) {
        callback(new Error("请同意协议"));
      } else {
        callback();
      }
    };
    var validatorPhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("手机号不能为空"));
      } else if (!/^1\d{10}$/.test(value)) {
        callback(new Error("手机号格式错误"));
      } else {
        callback();
      }
    };

    return {
      ruleForm: {
        name: "",
        surname: "",
        company: "",
        country: "",
        phone: "",
        mail: "",
        checked: "",
        content: "",
      },

      product_id: "",
      rules: {
        name: [{ required: true, message: "请输入名", trigger: "blur" }],
        surname: [{ required: true, message: "请输入姓", trigger: "blur" }],
        phone: [{ required: true, validator: validatorPhone, trigger: "blur" }],
        content: [
          { required: true, message: "请输入问题", trigger: "blur" },
          { min: 10, message: "问题最少10个字符", trigger: "blur" },
        ],
        company: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
          { min: 2, message: "公司名称最少两个字符", trigger: "blur" },
        ],
        mail: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"],
          },
        ],
        checked: [
          { required: true, message: "还没有同意协议", trigger: "change" },
          { validator: revalidatexieyi, trigger: "change", required: true },
        ],
      },
    };
  },

  methods: {
    filedCheck(prop) {
      let noSave = false;
      this.$refs.ruleForm.validateField(prop, (valid) => {
        if (valid) {
          noSave = true;
        }
      });
      return noSave;
    },

    onSubmit() {
      const validateFieldList = Object.keys(this.rules);
      const noSave = validateFieldList.some((i) => this.filedCheck(i));
      if (!noSave) {
        // 调用保存接口
        this.dataFormSubmit();
      }
    },

    dataFormSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.ruleForm.product_id = this.product_id;
          this.$api.user.savehelp(this.ruleForm).then((res) => {
            if (res.data.errno == 0) {
              // var options={
              //   message:"提交成功",
              // }
              // Message.success(options)
              this.$FUnitls.showInfo("提交成功", "success");
              var form = {
                realname: "",
                surname: "",
                company: "",
                country: "",
                mail: "",
                industry: "",
                content: "",
              };
              form.checked = this.ruleForm.checked;
              this.ruleForm = form;
            } else {
              // var options={
              //   message:res.data.errmsg,
              // }
              // Message.error(options)

              this.$FUnitls.showInfo(res.data.errmsg, "success");
            }
          });
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  mounted() {
    this.product_id = localStorage.getItem("goodsid");
    if (this.$cookies.get("userinfo") != null) {
      this.ruleForm.mail = this.$cookies.get("userinfo").mail;
      this.ruleForm.name = this.$cookies.get("userinfo").realname;
      this.ruleForm.surname = this.$cookies.get("userinfo").surname;
      this.ruleForm.phone = this.$cookies.get("userinfo").phone;
      this.ruleForm.company = this.$cookies.get("userinfo").compnay;
    }
  },
};
</script>

<style  scoped>
.frombody >>> .el-form--label-left .el-form-item__label {
  color: #333333;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 18px;
  font-weight: 540;
}
.xieyeitem >>> .el-form-item__content {
  margin-left: 0 !important;
}
.xieyeitem >>> .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #9f9f9f;
}
.xieyeitem >>> .el-form-item__content .el-checkbox__label {
  word-wrap: break-word;
  word-break: break-all;
}
.frombody >>> .el-input,
.el-select {
  width: 380px;
}
.mybotton {
  padding-bottom: 50px;
}
.frombody
  >>> .el-form-item.is-required:not(.is-no-asterisk)
  > .el-form-item__label:before {
  content: "";
  color: #ff1111;
  font-size: 18px;
  margin-right: 4px;
  font-family: Microsoft YaHei, Heiti SC, tahoma, arial, Hiragino Sans GB,
    "\5B8B\4F53", sans-serif;
}
.frombody
  >>> .el-form-item.is-required:not(.is-no-asterisk)
  > .el-form-item__label:after {
  /* content: ' ';
          color: #ff1111;
          background: url('/static/redstar.png') no-repeat center;
          background-size: 6px 6px;
          padding-right: 8px; */
  content: "*";
  color: #ff1111;
  font-size: 18px;
  margin-right: 4px;
  font-family: Microsoft YaHei, Heiti SC, tahoma, arial, Hiragino Sans GB,
    "\5B8B\4F53", sans-serif;
}
.xieyi {
  font-size: 14px;
  color: #9f9f9f;
  width: 100%;
  word-wrap: break-word;
  word-break: break-all;
  white-space: normal;
  overflow: hidden;
}
.xieyi >>> .el-checkbox__input {
  width: 3%;
  float: left;
  padding-top: 3px;
}

.xieyi >>> .el-checkbox__label {
  width: 97%;
  float: left;
  padding-left: 0;
}
.frombody >>> .el-button--primary {
  background-color: #2655ae;
  border-color: #2655ae;
}
.xieyi .yinsi {
  color: #2655ae;
}
.frombody >>> .el-textarea {
  width: 380px;
}
.xieyi >>> .el-checkbox__label a {
  color: #333;
  font-weight: 600;
  /* text-decoration: underline; */
}
</style>


// WEBPACK FOOTER //
// src/components/user/UserContactUs.vue